import React from 'react';
import { type FormikProps } from 'formik';

import { useMode } from '../../../../../contexts';
import {
  type FileData,
  UploadBox,
  DocumentBox,
  FILE_MANAGE_ORDER,
} from '../../../../../components';
import { AssessmentAccordion } from '../../../../Assessment';
import { type QualificationCheck } from '../../../graphql';
import { QualificationDetailMode } from '../types';

export type DocumentsProps = {
  fileNamePrefix?: string;
  formik: FormikProps<QualificationCheck>;
};

export const Documents: React.FunctionComponent<DocumentsProps> = props => {
  const { fileNamePrefix, formik } = props;
  const { mode } = useMode();
  const readonly = mode === QualificationDetailMode.MONITOR_VIEW;

  const files = formik.values.supportingDocuments ?? [];
  const handleUploadFile = async (
    order: number,
    file: FileData,
  ): Promise<boolean> => {
    const fileName = `${fileNamePrefix}_qualification_check`;
    let currentFiles = [...files];
    switch (order) {
      case FILE_MANAGE_ORDER.UPLOAD:
        currentFiles.push({
          name: fileName,
          id: file.id,
          link: '',
        });
        break;
      case FILE_MANAGE_ORDER.REMOVE:
        currentFiles = files.filter(f => f.id !== file.id);
        break;
      default:
    }
    await formik.setFieldValue('supportingDocuments', currentFiles);
    return true; // to fit component props type
  };
  return (
    <AssessmentAccordion
      className="!mb-4"
      title="Documents by AR"
      titlecolor="#951D1D"
      defaultExpanded
      AssessDetails={
        <>
          {readonly ? (
            <>
              {files.length > 0 ? (
                <DocumentBox file={files[0]} />
              ) : (
                <div className="pl-0">{'N/A'}</div>
              )}
            </>
          ) : (
            <div className="px-10 mb-4">
              <UploadBox
                files={files}
                maximumNum={1}
                handleFilesChange={handleUploadFile}
              />
            </div>
          )}
        </>
      }
    />
  );
};
